import { render } from "./QuizSteps.vue?vue&type=template&id=b234a002"
import script from "./QuizSteps.vue?vue&type=script&lang=js"
export * from "./QuizSteps.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__